import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import axios from 'axios';
import { GrupoContext } from '../GrupoContext';
import Sidebar from '../componenteExtra/SidebarLider';
import SessionManager from '../componenteExtra/SessionManager';
import * as XLSX from 'xlsx';

const ActividadesSinDocumentar = () => {
    const navigate = useNavigate();
    const [actividades, setActividades] = useState([]);
    const { grupo, setGrupo } = useContext(GrupoContext);

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const storedGrupo = localStorage.getItem('grupo');
        if (storedGrupo && !grupo) {
            setGrupo(storedGrupo);
        }

        if (grupo) {
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/waiting_for_documentation_for_number_group/${grupo}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then(response => {
                    setActividades(response.data);
                })
                .catch(error => console.error('Error fetching data: ', error));
        }
    }, [grupo, setGrupo]);

    const handleContinue = () => {
        navigate('/menulider');
    };

    // DESCARGAR EXCEL
    const handleDownloadExcel = () => {
        const data = actividades.map(a => ({
            'Código de proyecto': a.codigo_proyecto,
            'Razón social': a.razon_social,
            'Filial': a.filial,
            'Solicitante': a.nombre_solicitante,
            'Tipo de trabajo': a.tipo_solicitud,
            'Regulación': a.tipo_regulacion,
            'Socio de auditoría': a.encargado_auditoria,
            'Rubro': a.rubro_get,
            'Jefe de Grupo': a.jefe_grupo,
            'Subrogante': a.subrogante,
            'Fecha entrega info': a.fecha_entrega_informacion
                ? new Date(a.fecha_entrega_informacion).toLocaleDateString('es-ES')
                : '',
            'Fecha cortes auditoría': a.fecha_corte_auditoria
                ? new Date(a.fecha_corte_auditoria).toLocaleDateString('es-ES')
                : '',
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Actividades');
        XLSX.writeFile(wb, `Actividades_Grupo_${grupo}_Sin_Documentar.xlsx`);
    };

    const totalActividades = actividades.length;

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel" style={{ position: 'relative' }}>
                    <div className="panel-header">
                        <h1>Actividades en espera de documentación - Grupo {grupo}</h1>
                        <h2>Total Actividades: {totalActividades}</h2>
                    </div>

                    {/* BOTÓN REPORTE ARRIBA A LA DERECHA */}
                    <button
                        onClick={handleDownloadExcel}
                        disabled={totalActividades === 0}
                        style={{
                            position: 'absolute',
                            top: '50px',
                            right: '15px',
                            backgroundColor: totalActividades === 0 ? '#6c757d' : '#28a745',
                            color: 'white',
                            border: 'none',
                            padding: '20px 16px',
                            borderRadius: '6px',
                            cursor: totalActividades === 0 ? 'not-allowed' : 'pointer',
                            fontSize: '0.95rem',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                            zIndex: 10,
                            opacity: totalActividades === 0 ? 0.65 : 1,
                        }}
                        onMouseDown={(e) => {
                            if (totalActividades === 0) return;
                            e.currentTarget.style.transform = 'scale(0.96)';
                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.2)';
                        }}
                        onMouseUp={(e) => {
                            if (totalActividades === 0) return;
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.15)';
                        }}
                    >
                        <svg width="15" height="15" viewBox="0 0 384 512" fill="white" xmlns="http://www.w3.org/2000/svg">
                            <path d="M48 448V64c0-35.3 28.7-64 64-64H224v96c0 35.3 28.7 64 64 64h96v288c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64zm96-80l64 64 64-64H304l-80 80 80 80H208l-64-64-64 64H48l80-80-80-80H144z"/>
                        </svg>
                        Reporte
                    </button>

                    {/* TABLA */}
                    <table className="activities-table">
                        <thead>
                            <tr>
                                <th>Código de proyecto</th>
                                <th>Razón social</th>
                                <th>Filial</th>
                                <th>Solicitante</th>
                                <th>Tipo de trabajo</th>
                                <th>Regulación</th>
                                <th>Socio de auditoría</th>
                                <th>Rubro</th>
                                <th>Jefe de Grupo</th>
                                <th>Subrogante</th>
                                <th>Fecha de entrega de la información</th>
                                <th>Fecha Corte Auditoria</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actividades.map(actividad => (
                                <tr key={actividad.id}>
                                    <td>{actividad.codigo_proyecto}</td>
                                    <td>{actividad.razon_social}</td>
                                    <td>{actividad.filial}</td>
                                    <td>{actividad.nombre_solicitante}</td>
                                    <td>{actividad.tipo_solicitud}</td>
                                    <td>{actividad.tipo_regulacion}</td>
                                    <td>{actividad.encargado_auditoria}</td>
                                    <td>{actividad.rubro_get}</td>
                                    <td>{actividad.jefe_grupo}</td>
                                    <td>{actividad.subrogante}</td>
                                    <td>{actividad.fecha_entrega_informacion ? new Date(actividad.fecha_entrega_informacion).toLocaleDateString('es-ES') : ''}</td>
                                    <td>{actividad.fecha_corte_auditoria ? new Date(actividad.fecha_corte_auditoria).toLocaleDateString('es-ES') : ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* BOTÓN CONTINUAR: SIN CAMBIOS */}
                    <button className="continue-button" onClick={handleContinue}>
                        Continuar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ActividadesSinDocumentar;